import {
	Avatar,
	Breadcrumb,
	Button,
	Card,
	Col,
	Form,
	Input,
	Layout,
	message,
	Row,
	Switch,
	Tag,
	Typography,
	Upload,
} from "antd";
import downloadjs from "downloadjs";
import html2canvas from "html2canvas";
import React from "react";
import {
	IoCameraOutline,
	IoCheckmark,
	IoLinkOutline,
	IoLogoFacebook,
	IoLogoGoogle,
	IoLogoInstagram,
	IoLogoLinkedin,
	IoLogoTwitter,
	IoLogoWhatsapp,
	IoLogoYoutube,
} from "react-icons/io5";
import ReactInputMask from "react-input-mask";
import { Link, Navigate } from "react-router-dom";
import {
	getToken,
	getUPLOADAPI,
	POST_API,
	POST_CATCH,
	setPath,
	titleWeb,
	verifyConfig,
} from "../../../services/api";
// CONTROLLER
import Page403 from "../../Controller/Page403";
import PageLoad from "../../Controller/PageLoad";

class AdminParteContrariaForm extends React.Component {
	state = {
		_navigate: false,
		_loading: false,
		_screen: true,
		_dados: null,
		_params: window.location.href.split("/"),
		defaultValue: { ID: 0 },
		doc: false,
	};

	back = "/painel/partecontraria";

	routes = [
		{ title: <Link to={this.back}>Partes Contrária</Link> },
		{ title: this.props.type === "add" ? "Adicionar" : "Editar" },
	];

	componentDidMount = () => {
		titleWeb("Partes Contrária");
		setPath("opposing_part");
		if (this.props.type === "add") {
			this.setState({ _screen: false });
		} else if (this.props.type === "edit") {
			this.onView();
		}
	};

	buscaCEP = async (val) => {
		var cep = String(val.target.value).replace("-", "");
		this.setState({ _screen: true });
		await fetch("https://viacep.com.br/ws/" + cep + "/json/")
			.then((rs) => rs.json())
			.then((res) => {
				if (res.erro) {
					message.warning("CEP inválido");
				} else {
					this.setState({
						defaultValue: {
							...this.state.defaultValue,
							STREET: res.logradouro,
							DISTRICT: res.bairro,
							CITY: res.localidade,
							STATE: res.uf,
							CEP: cep,
						},
					});
				}
			})
			.catch(() => POST_CATCH())
			.finally(() => this.setState({ _screen: false }));
	};

	onView = async () => {
		await POST_API("/opposing_part/search.php", {
			token: getToken(),
			type: "view",
			filter: JSON.stringify({ ID: this.state._params[5] }),
		})
			.then((rs) => rs.json())
			.then((res) => {
				this.setState({ defaultValue: res.data, _screen: false });
				if (String(res.data.CPFCNPJ).length > 14) this.setState({ doc: true });
			})
			.catch(() => POST_CATCH());
	};

	onSend = (values) => {
		this.setState({ _screen: true });
		POST_API("/opposing_part/self-pass.php", {
			token: getToken(),
			master: JSON.stringify(values),
		})
			.then((rs) => rs.json())
			.then((res) => {
				if (res.return) {
					message.success({ content: res.msg, key: "screen" });
				} else {
					message.warning({ content: res.msg, key: "screen" });
				}
			})
			.catch(() => {
				message.error({
					content: "Não foi possível estabelecer uma conexão com o sistema",
					key: "screen",
				});
			})
			.finally(() => this.setState({ _screen: false }));
	};

	onSendAccount = (values) => {
		this.setState({ _loading: true });
		POST_API("/opposing_part/saveall.php", {
			token: getToken(),
			master: JSON.stringify(this.state.defaultValue),
		})
			.then((rs) => rs.json())
			.then((res) => {
				if (res.return) {
					message.success({ content: res.msg, key: "screen" });
					this.setState({ _navigate: true });
				} else {
					message.warning({ content: res.msg, key: "screen" });
				}
			})
			.catch(() => {
				message.error({
					content: "Não foi possível estabelecer uma conexão com o sistema",
					key: "screen",
				});
			})
			.finally(() => this.setState({ _loading: false }));
	};

	onChangePic = (value) => {
		if (value.file.response?.url) {
			this.setState({ _screen: true });
			POST_API("/opposing_part/save.php", {
				token: getToken(),
				master: JSON.stringify({
					AVATAR: value.file.response?.url,
					ID: this.state._params[5],
				}),
			})
				.then((rs) => rs.json())
				.then((res) => {
					if (res.return) {
						message.success({ content: res.msg, key: "screen" });
					} else {
						message.warning({ content: res.msg, key: "screen" });
					}
				})
				.catch(() => {
					message.error({
						content: "Não foi possível estabelecer uma conexão com o sistema",
						key: "screen",
					});
				})
				.finally(() => this.onView());
		}
	};

	onChangeName = (value) => {
		this.setState({ _screen: true });
		POST_API("/opposing_part/save.php", {
			token: getToken(),
			master: JSON.stringify({ NAME: value, ID: this.state._params[5] }),
		})
			.then((rs) => rs.json())
			.then((res) => {
				if (res.return) {
					message.success({ content: res.msg, key: "screen" });
				} else {
					message.warning({ content: res.msg, key: "screen" });
				}
			})
			.catch(() => {
				message.error({
					content: "Não foi possível estabelecer uma conexão com o sistema",
					key: "screen",
				});
			})
			.finally(() => this.onView());
	};

	downloadQRCode = async () => {
		const canvas = await html2canvas(document.getElementById("myqrcode"));
		const dataURL = canvas.toDataURL("image/png");
		downloadjs(dataURL, "download.png", "image/png");
	};

	onCopy = () => {
		window.navigator.clipboard.writeText(
			"https://jurisvip.adsolucoestecnologia.com.br",
		);
		message.success({ content: "URL copiada", key: "screen" });
	};

	onChangeField = (a, b) => {
		if (a.length > 0) {
			var name = a[0].name[0];
			var value = a[0].value;
			this.setState({
				defaultValue: {
					...this.state.defaultValue,
					[name]: value,
				},
			});
		}
	};

	render = () => {
		if (this.state._navigate) return <Navigate to={this.back} />;
		if (!verifyConfig(`${this.props.per}.${this.props.type}`))
			return <Page403 />;

		return (
			<Layout>
				<Layout.Content className={"admin-container"}>
					<Row gutter={[8, 8]}>
						<Col span={18}>
							<Breadcrumb items={this.routes} />
						</Col>
						<Col
							span={6}
							style={{ display: "flex", justifyContent: "flex-end" }}
						>
							<Link to={this.back}>
								<Button
									className="sys-btn-primary sys-btn-small"
									shape="round"
									size="small"
									type="primary"
								>
									Voltar
								</Button>
							</Link>
						</Col>
						{this.state._screen ? (
							<PageLoad />
						) : (
							<>
								{true ? (
									<>
										<Col md={24} xs={24}>
											<Form
												initialValues={this.state.defaultValue}
												layout="vertical"
												onFieldsChange={(a, b) => this.onChangeField(a, b)}
												onFinish={this.onSendAccount}
											>
												<Button
													className="fabbutton btn-primary"
													htmlType="submit"
													shape="circle"
													size="large"
												>
													<IoCheckmark color="#FFF" size={22} />
												</Button>
												<Row gutter={[8, 8]}>
													<Col span={24}>
														<Card bordered size="small" title="Dados">
															<Row gutter={[16, 0]}>
																<Col md={18} xs={24}>
																	<Form.Item hidden name="ID">
																		<Input type="text" />
																	</Form.Item>
																	<Form.Item
																		label="Nome Completo"
																		name="NAME"
																		rules={[
																			{
																				required: true,
																				message: "Campo Obrigatório",
																			},
																		]}
																	>
																		<Input type="text" />
																	</Form.Item>
																</Col>
																<Col md={6} xs={24}>
																	<Form.Item
																		label={this.state.doc ? "CNPJ" : "CPF"}
																		name="CPFCNPJ"
																		rules={[
																			{
																				required: true,
																				message: "Campo Obrigatório",
																			},
																		]}
																	>
																		<ReactInputMask
																			mask={
																				this.state.doc
																					? "99.999.999/9999-99"
																					: "999.999.999-99"
																			}
																			maskChar={""}
																			maxLength={this.state.doc ? 18 : 14}
																			placeholder={
																				this.state.doc ? "CNPJ" : "CPF"
																			}
																		>
																			{(props) => <Input {...props} />}
																		</ReactInputMask>
																	</Form.Item>
																	<Switch
																		checked={this.state.doc}
																		checkedChildren="CNPJ"
																		onChange={(v) => this.setState({ doc: v })}
																		style={{
																			position: "absolute",
																			right: 13,
																			top: 35,
																		}}
																		unCheckedChildren="CPF"
																	/>
																</Col>
																<Col md={12} xs={24}>
																	<Form.Item label="Apresentação" name="DESC">
																		<Input.TextArea
																			maxLength={1000}
																			rows={4}
																			showCount
																			type="text"
																		/>
																	</Form.Item>
																</Col>
																<Col md={12} xs={24}>
																	<Form.Item label="Observações" name="ABOUT">
																		<Input.TextArea
																			maxLength={1000}
																			rows={4}
																			showCount
																			type="text"
																		/>
																	</Form.Item>
																</Col>
															</Row>
														</Card>
													</Col>
													<Col span={24}>
														<Card bordered size="small" title="Endereço">
															<Row gutter={[16, 0]}>
																<Col md={6} xs={24}>
																	<Form.Item label="CEP" name="CEP">
																		<ReactInputMask
																			mask={"99999-999"}
																			maskChar={""}
																			maxLength={9}
																			onBlur={this.buscaCEP}
																		>
																			{(props) => <Input {...props} />}
																		</ReactInputMask>
																	</Form.Item>
																</Col>
																<Col md={14} xs={24}>
																	<Form.Item label="Endereço" name="STREET">
																		<Input type="text" />
																	</Form.Item>
																</Col>
																<Col md={4} xs={24}>
																	<Form.Item label="Número" name="NUMBER">
																		<Input type="text" />
																	</Form.Item>
																</Col>
																<Col md={10} xs={24}>
																	<Form.Item label="Bairro" name="DISTRICT">
																		<Input type="text" />
																	</Form.Item>
																</Col>
																<Col md={10} xs={24}>
																	<Form.Item label="Cidade" name="CITY">
																		<Input type="text" />
																	</Form.Item>
																</Col>
																<Col md={4} xs={24}>
																	<Form.Item label="UF" name="STATE">
																		<Input maxLength={2} type="text" />
																	</Form.Item>
																</Col>
															</Row>
														</Card>
													</Col>
													<Col span={24}>
														<Card bordered size="small" title="Contato">
															<Row gutter={[16, 0]}>
																<Col md={16} xs={24}>
																	<Form.Item label="E-mail" name="EMAIL">
																		<Input
																			addonBefore={<IoLogoGoogle />}
																			type="email"
																		/>
																	</Form.Item>
																</Col>
																<Col md={8} xs={24}>
																	<Form.Item label="Whatsapp" name="WHATSAPP">
																		<ReactInputMask
																			mask={"+55 (99) 99999-9999"}
																			maskChar={""}
																			maxLength={19}
																			value={this.state.defaultValue?.WHATSAPP}
																		>
																			{(props) => (
																				<Input
																					{...props}
																					addonBefore={<IoLogoWhatsapp />}
																				/>
																			)}
																		</ReactInputMask>
																	</Form.Item>
																</Col>
																<Col md={8} xs={24}>
																	<Form.Item label="Instagram" name="INSTAGRAM">
																		<Input
																			addonBefore={<IoLogoInstagram />}
																			type="url"
																		/>
																	</Form.Item>
																</Col>
																<Col md={8} xs={24}>
																	<Form.Item label="Facebook" name="FACEBOOK">
																		<Input
																			addonBefore={<IoLogoFacebook />}
																			type="url"
																		/>
																	</Form.Item>
																</Col>
																<Col md={8} xs={24}>
																	<Form.Item label="Twitter" name="TWITTER">
																		<Input
																			addonBefore={<IoLogoTwitter />}
																			type="url"
																		/>
																	</Form.Item>
																</Col>
																<Col md={8} xs={24}>
																	<Form.Item label="LinkedIn" name="LINKEDIN">
																		<Input
																			addonBefore={<IoLogoLinkedin />}
																			type="url"
																		/>
																	</Form.Item>
																</Col>
																<Col md={8} xs={24}>
																	<Form.Item label="Youtube" name="YOUTUBE">
																		<Input
																			addonBefore={<IoLogoYoutube />}
																			type="url"
																		/>
																	</Form.Item>
																</Col>
																<Col md={8} xs={24}>
																	<Form.Item label="Site" name="SITE">
																		<Input
																			addonBefore={<IoLinkOutline />}
																			type="url"
																		/>
																	</Form.Item>
																</Col>
															</Row>
														</Card>
													</Col>
												</Row>
											</Form>
										</Col>
									</>
								) : (
									<>
										<Col md={8} xs={24}>
											<Row gutter={[8, 8]}>
												<Col span={24}>
													<Card
														bordered
														size="small"
														style={{ paddingTop: 20 }}
													>
														<Row
															align={"middle"}
															justify="center"
															style={{ flexDirection: "column" }}
														>
															<Avatar
																shape="circle"
																size={200}
																src={this.state.defaultValue.AVATAR}
																style={{ marginBottom: 12 }}
															/>
															<Upload
																accept="image/jpg,image/jpeg,image/png"
																action={getUPLOADAPI}
																className={"admin-profile-upload"}
																maxCount={1}
																onChange={this.onChangePic}
																showUploadList={false}
															>
																<Button
																	className="btn-nav"
																	shape="circle"
																	type="default"
																>
																	<IoCameraOutline size={20} />
																</Button>
															</Upload>
															<Typography.Paragraph
																className={"admin-profile-name"}
																editable={{
																	tooltip: false,
																	onChange: this.onChangeName,
																}}
															>
																{this.state.defaultValue.NAME}
															</Typography.Paragraph>
															<Tag color={this.state.defaultValue.STATUS_COLOR}>
																Parte Adversária
															</Tag>
														</Row>
													</Card>
												</Col>
												{/* <Col span={24}>
                                                    <Card title="Compartilhar Perfil" bordered size="small">
                                                        <Row justify="center" align={'middle'} style={{flexDirection: 'column'}} gutter={[8,8]}>
                                                            <Col span={24} id="myqrcode">
                                                                <QRCode                                                                
                                                                    size={200}
                                                                    value={'https://jurisvip.adsolucoestecnologia.com.br'}
                                                                    icon={logo}
                                                                />
                                                            </Col>
                                                            <Col span={24}>
                                                                <Button type="primary" onClick={this.downloadQRCode} shape="round">
                                                                    Download
                                                                </Button>
                                                            </Col>
                                                            <Col span={24}>
                                                                <Button type="link" className="btn-link" onClick={this.onCopy} shape="round">
                                                                    Copiar URL
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </Card>
                                                </Col> */}
											</Row>
										</Col>
										<Col md={16} xs={24}>
											<Form
												initialValues={this.state.defaultValue}
												layout="vertical"
												onFieldsChange={(a, b) => this.onChangeField(a, b)}
												onFinish={this.onSendAccount}
											>
												<Button
													className="fabbutton btn-primary"
													htmlType="submit"
													shape="circle"
													size="large"
												>
													<IoCheckmark color="#FFF" size={22} />
												</Button>
												<Row gutter={[8, 8]}>
													<Col span={24}>
														<Card bordered size="small" title="Perfil Público">
															<Row gutter={[16, 0]}>
																<Form.Item hidden name="ID">
																	<Input type="text" />
																</Form.Item>
																<Col md={18} xs={24}>
																	<Form.Item
																		label={this.state.doc ? "CNPJ" : "CPF"}
																		name="CPFCNPJ"
																	>
																		<ReactInputMask
																			mask={
																				this.state.doc
																					? "99.999.999/9999-99"
																					: "999.999.999-99"
																			}
																			maskChar={""}
																			maxLength={this.state.doc ? 18 : 14}
																			placeholder={
																				this.state.doc ? "CNPJ" : "CPF"
																			}
																		>
																			{(props) => <Input {...props} />}
																		</ReactInputMask>
																	</Form.Item>
																	<Switch
																		checked={this.state.doc}
																		checkedChildren="CNPJ"
																		onChange={(v) => this.setState({ doc: v })}
																		style={{
																			position: "absolute",
																			right: 13,
																			top: 35,
																		}}
																		unCheckedChildren="CPF"
																	/>
																</Col>
																<Col md={6} xs={24}>
																	<Form.Item
																		label="Data Nascimento"
																		name="BIRTHDAY"
																	>
																		<Input type="date" />
																	</Form.Item>
																</Col>
																<Col md={24} xs={24}>
																	<Form.Item label="Apresentação" name="DESC">
																		<Input.TextArea
																			maxLength={1000}
																			rows={4}
																			showCount
																			type="text"
																		/>
																	</Form.Item>
																</Col>
																<Col md={24} xs={24}>
																	<Form.Item label="Sobre" name="ABOUT">
																		<Input.TextArea
																			maxLength={1000}
																			rows={4}
																			showCount
																			type="text"
																		/>
																	</Form.Item>
																</Col>
															</Row>
														</Card>
													</Col>
													<Col span={24}>
														<Card bordered size="small" title="Endereço">
															<Row gutter={[16, 0]}>
																<Col md={6} xs={24}>
																	<Form.Item label="CEP" name="CEP">
																		<ReactInputMask
																			mask={"99999-999"}
																			maskChar={""}
																			maxLength={9}
																			onBlur={this.buscaCEP}
																		>
																			{(props) => <Input {...props} />}
																		</ReactInputMask>
																	</Form.Item>
																</Col>
																<Col md={14} xs={24}>
																	<Form.Item label="Endereço" name="STREET">
																		<Input type="text" />
																	</Form.Item>
																</Col>
																<Col md={4} xs={24}>
																	<Form.Item label="Número" name="NUMBER">
																		<Input type="text" />
																	</Form.Item>
																</Col>
																<Col md={10} xs={24}>
																	<Form.Item label="Bairro" name="DISTRICT">
																		<Input type="text" />
																	</Form.Item>
																</Col>
																<Col md={10} xs={24}>
																	<Form.Item label="Cidade" name="CITY">
																		<Input type="text" />
																	</Form.Item>
																</Col>
																<Col md={4} xs={24}>
																	<Form.Item label="UF" name="STATE">
																		<Input maxLength={2} type="text" />
																	</Form.Item>
																</Col>
															</Row>
														</Card>
													</Col>
													<Col span={24}>
														<Card bordered size="small" title="Contato">
															<Row gutter={[16, 0]}>
																<Col md={16} xs={24}>
																	<Form.Item label="E-mail" name="EMAIL">
																		<Input
																			addonBefore={<IoLogoGoogle />}
																			type="email"
																		/>
																	</Form.Item>
																</Col>
																<Col md={8} xs={24}>
																	<Form.Item label="Whatsapp" name="WHATSAPP">
																		<ReactInputMask
																			mask={"+55 (99) 99999-9999"}
																			maskChar={""}
																			maxLength={19}
																			value={this.state.defaultValue?.WHATSAPP}
																		>
																			{(props) => (
																				<Input
																					{...props}
																					addonBefore={<IoLogoWhatsapp />}
																				/>
																			)}
																		</ReactInputMask>
																	</Form.Item>
																</Col>
																<Col md={8} xs={24}>
																	<Form.Item label="Instagram" name="INSTAGRAM">
																		<Input
																			addonBefore={<IoLogoInstagram />}
																			type="url"
																		/>
																	</Form.Item>
																</Col>
																<Col md={8} xs={24}>
																	<Form.Item label="Facebook" name="FACEBOOK">
																		<Input
																			addonBefore={<IoLogoFacebook />}
																			type="url"
																		/>
																	</Form.Item>
																</Col>
																<Col md={8} xs={24}>
																	<Form.Item label="Twitter" name="TWITTER">
																		<Input
																			addonBefore={<IoLogoTwitter />}
																			type="url"
																		/>
																	</Form.Item>
																</Col>
																<Col md={8} xs={24}>
																	<Form.Item label="LinkedIn" name="LINKEDIN">
																		<Input
																			addonBefore={<IoLogoLinkedin />}
																			type="url"
																		/>
																	</Form.Item>
																</Col>
																<Col md={8} xs={24}>
																	<Form.Item label="Youtube" name="YOUTUBE">
																		<Input
																			addonBefore={<IoLogoYoutube />}
																			type="url"
																		/>
																	</Form.Item>
																</Col>
																<Col md={8} xs={24}>
																	<Form.Item label="Site" name="SITE">
																		<Input
																			addonBefore={<IoLinkOutline />}
																			type="url"
																		/>
																	</Form.Item>
																</Col>
															</Row>
														</Card>
													</Col>
												</Row>
											</Form>
										</Col>
									</>
								)}
							</>
						)}
					</Row>
				</Layout.Content>
			</Layout>
		);
	};
}

export default AdminParteContrariaForm;
